import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api/menuitem';
import { MenuDataService } from 'src/app/services/menu-data.service';
import { AccessUserInfo } from 'src/app/models';

@Component({
  selector: 'bart-setting-menu',
  templateUrl: './setting-menu.component.html',
  styleUrls: ['./setting-menu.component.scss']
})
export class SettingMenuComponent implements OnInit {
items:  MenuItem[];
userDetail :any  =null;
showMenu:boolean = true;
activeTab: string ="parts";

  constructor(private _menuService:MenuDataService) { }

  ngOnInit() {
    this.items=this._menuService.getSettingMenuList();
    this.userDetail = AccessUserInfo.getUserInfo();
    if(this.userDetail.bartRoleCode.toLowerCase() == "analyst")
    {
      this.showMenu = false;
      this.activeTab = "vision";
    }

  }

  public handleChange(event){ 
if (event.index== 0)
{
  this.activeTab = "parts";
}
if (event.index== 1)
{
  this.activeTab = "test";
}
if (event.index== 2)
{
  this.activeTab = "vision";
}
if (event.index== 3)
{
  this.activeTab = "format";
}
 
  }

}
